import { useRouter } from "next/router";
import en from "../public/locale/en";
import hi from "../public/locale/hi";
import ta from "../public/locale/ta";

const ArticleFooter = () => {
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : locale === "hi" ? hi : ta;
  return (
    <footer className="bg-gray-100 py-8">
      <div className="container mx-auto">
        <p className="text-justify text-gray-500 text-sm">
          {
            t[
            "Insurance is a subject matter of solicitation. Niva Bupa Health Insurance Company Limited (formerly known as Max Bupa Health Insurance Company Limited) (IRDAI Registration Number 145, Category:Health), &apos;Bupa&apos; and &apos;HEARTBEAT&apos; logo are registered trademarks of their respective owners and are being used by Niva Bupa Health Insurance Company Limited (formerly known as Max Bupa Health Insurance Company Limited) under license. Registered office:- C-98 Lajpat Nagar 1, New Delhi-110024, Customer Helpline: 1860-500-8888. Fax: +91 11 41743397. Website: www.nivabupa.com. CIN: L66000DL2008PLC182918."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "First-time premium shown is calculated on the base sum insured (Rs 5 lacs for Health Companion, Heartbeat, Health Premia, Health Pulse and GoActiveTM, Rs 10.5 lacs for Money Saver, and Rs 10 lacs for Health Assurance) of an individual aged 25 residing in Delhi NCR region. The premium changes as per the product features selected and the insured details you submit on the website."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Terms and conditions apply, please refer to the brochure for complete details."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Base premium is calculated for Health Companion for an individual aged 25, residing in Delhi NCR. The premium amount is illustrative only and it may vary over the period depending on the type of product, features/add-ons selected, changes to product version, inflation rates, and underwriting decision of the company."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Aspire max: Premium in inclusive of GST and calculated for a 25-year-old individual living in Delhi with 5 Lacs Aspire Sum Insured (Gold+ variant) and 95 Lacs sum insured from Health Recharge (with 5 Lacs Deductible)"
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Aspire product Premium: Premium in inclusive of GST and calculated for a 25-year-old individual living in Delhi with 5 Lacs Sum Insured (Gold+ variant)"
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "*The discount will vary with the product chosen. The discount is applicable for the following products: GoActive – 12%; ReAssure – 5%; Health Pulse – 12%; Health Recharge – 5%; Health Assurance – 10%."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "**Niva Bupa processes pre-auth requests within 30 minutes for all active policies, subject to receiving all documents and information(s) up to Niva Bupa’s satisfaction. The above commitment does not include pre-authorization settlement at the time  of discharge or system outage. For more details on terms and conditions, exclusions, and waiting period, please read the sales brochure before concluding a sale."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "***NOL: Active lives as at March 31, 2021. Number of hospital networks shown is an approximate figure and is subject to change without prior notice."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {t["BEWARE OF SPURIOUS / FRAUD PHONE CALLS!"]}
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Do not share your confidential information like Debit / credit card number, Internet Banking User ID/Password, Pin, CVV, OTP, etc. with anyone."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Avoid clicking on attachments / payment link received in mails / message from unknown sources."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "IRDAI is not involved in activities like selling insurance policies, announcing bonus or investment or premium. Public receiving such phone calls are requested to lodge a police complaint."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Do not respond to unsolicited and attractive offers received through unidentified calls, emails, SMSs, and other social media platforms."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Beware of misleading telephone calls from people posing as Niva Bupa officials, agents, IRDAI Officials, Officials from ECI (Office of the Executive Council of Insurers) etc. and offering alluring benefits or sharing false information on your policy or on Niva Bupa."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "Niva Bupa shall not be responsible for any loss or damages whatsoever for any acts or omissions arising out of such spurious calls, and all customers are advised to contact our customer care at 1860-500-8888 and verify any representations or promises made by any such spurious callers before acting upon the same."
            ]
          }
        </p>

        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "****The name of the Company has been changed from Max Bupa Health Insurance Company Limited to Niva Bupa Health Insurance Company Limited effective 5th July, 2021."
            ]
          }
        </p>
        <p className="text-justify text-gray-500 text-sm mt-4">
          {
            t[
            "****The name of the Company has been changed from Max Bupa Health Insurance Company Limited to Niva Bupa Health Insurance Company Limited effective 5th July, 2021."
            ]
          }
        </p>
        <p className="text-justify text-gray-500 text-sm mt-4">
          (8) Heart Beat: Quoted premium is inclusive of GST for INR 5 lacs Sum
          Insured with a policy tenure of 1 year for 1 Adult aged 25 years
          living in Delhi with Zone 1 Option (all India coverage without any
          co-payment)
        </p>
        <p className="text-justify text-gray-500 text-sm mt-4">
          (11) Quoted premium is inclusive of GST for INR 5 lacs Sum Insured with a policy tenure of 1 year for 1 Adult aged 25 years living in Delhi, at Level 0 of “Favourable claim Discount
        </p>
        <p className="text-justify text-gray-500 text-sm mt-4">
          ^Claim Promise with Zero deductions
        </p>
        <p className="text-justify text-gray-500 text-sm mt-4">
          This is applicable for ReAssure, Reassure 2.0, Aspire and Rise product.
        </p>

        <ul className="list-[lower-alpha] mx-12">
          <li className="text-justify text-gray-500 text-sm mt-4">
            Buy your Niva Bupa policy for coverage of 10 Lacs or above, with Safeguard+ add on
          </li>
          <li className="text-justify text-gray-500 text-sm mt-4">
            Intimate Niva Claim helpline (1860-500-8888) 48 hours before hospitalization for non-emergency treatments
          </li>
          <li className="text-justify text-gray-500 text-sm mt-4">
            Choose any hospital from the list of recommendations given by Claim Advisor for your treatment, via cashless facility
          </li>
          <li className="text-justify text-gray-500 text-sm mt-4">
            Receive a claim promise with zero deduction, in accordance with policy inclusions and T&C
          </li>
          <li className="text-justify text-gray-500 text-sm mt-4">
            Claims Exclusions: the promise will not apply to claims arising due to exclusions stated in the policy (e.g.- non-disclosure, fraud, standard exclusions, waiting periods etc.)
          </li>
        </ul>

      </div>
    </footer>
  );
};

export default ArticleFooter;
